export interface MenuItem {
  label: string;
  link: string;
  iconmoonWeb: string;
  iconmoonMobile: string;
  flag?: string;
  matcher?: (router: { asPath: string }) => boolean;
}

interface MenuGroup {
  title?: string;
  subMenu: MenuItem[];
}

const SECURITIES_URL = '/securities';

const realTradingMenu: MenuGroup[] = [
  {
    title: 'Trading',
    subMenu: [
      {
        label: 'Orderbook',
        link: '/orderbook',
        iconmoonWeb: 'icon-tradesmall_orderbook',
        iconmoonMobile: 'icon-menu3_orderbook',
        matcher: (router) => {
          const { asPath } = router;

          if (asPath.includes('/orderbook')) {
            return true;
          }

          return false;
        },
      },
      {
        label: 'Portfolio',
        link: `${SECURITIES_URL}/portfolio`,
        iconmoonWeb: 'icon-tradesmall_portfolio',
        iconmoonMobile: 'icon-menu3_portfolio',
        matcher: (router) => {
          const { asPath } = router;

          if (asPath.includes('/portfolio')) {
            return true;
          }

          return false;
        },
      },
      {
        label: 'Order',
        link: `${SECURITIES_URL}/order`,
        iconmoonWeb: 'icon-tradesmall_order',
        iconmoonMobile: 'icon-menu3_order',
        matcher: (router) => {
          const { asPath } = router;

          if (asPath.includes('/order') && !asPath.includes('/orderbook')) {
            return true;
          }

          return false;
        },
      },
      {
        label: 'History',
        link: `${SECURITIES_URL}/history`,
        iconmoonWeb: 'icon-tradesmall_history',
        iconmoonMobile: 'icon-menu3_history',
        matcher: (router) => {
          const { asPath } = router;

          if (asPath.includes('/history')) {
            return true;
          }

          return false;
        },
      },
      {
        label: 'Transfer Saham',
        link: `${SECURITIES_URL}/stocktransfer`,
        iconmoonWeb: 'icon-briefcase_arrow',
        iconmoonMobile: 'icon-briefcase_arrow',
        matcher: (router) => {
          const { asPath } = router;

          if (asPath.includes('/stocktransfer')) {
            return true;
          }

          return false;
        },
      },
    ],
  },
  {
    title: 'Settings',
    subMenu: [
      {
        label: 'Trading Profile',
        link: '/profile/account/trading',
        iconmoonWeb: 'icon-tradesmall_account',
        iconmoonMobile: 'icon-menu3_account',
        matcher: (router) => {
          const { asPath } = router;

          if (asPath.includes('/profile/account/trading')) {
            return true;
          }

          return false;
        },
      },
      {
        label: 'Security',
        link: `${SECURITIES_URL}/settings`,
        iconmoonWeb: 'icon-tradesmall_password',
        iconmoonMobile: 'icon-menu3_password',
        matcher: (router) => {
          const { asPath } = router;

          if (asPath.includes('/settings')) {
            return true;
          }

          return false;
        },
      },
      {
        label: 'E-Statement',
        link: `${SECURITIES_URL}/estatement`,
        iconmoonWeb: 'icon-securities-file',
        iconmoonMobile: 'icon-securities-file',
        matcher: (router) => {
          const { asPath } = router;

          if (asPath.includes('/estatement')) {
            return true;
          }

          return false;
        },
      },

      {
        label: 'Deposit',
        link: `${SECURITIES_URL}/deposit`,
        iconmoonWeb: 'icon-tradesmall_deposit',
        iconmoonMobile: 'icon-menu3_deposit',
        matcher: (router) => {
          const { asPath } = router;

          if (asPath.includes('/deposit')) {
            return true;
          }

          return false;
        },
      },
      {
        label: 'Withdrawal',
        link: `${SECURITIES_URL}/withdrawal`,
        iconmoonWeb: 'icon-tradesmall_withdraw',
        iconmoonMobile: 'icon-menu3_withdraw',
        matcher: (router) => {
          const { asPath } = router;

          if (asPath.includes('/withdrawal')) {
            return true;
          }

          return false;
        },
      },
    ],
  },
  {
    subMenu: [
      {
        label: 'Live Support', // this label is used by handleNavigation() in ./TradingMenuItem.tsx
        link: '',
        iconmoonWeb: 'icon-tradesmall_support',
        iconmoonMobile: 'icon-menu3_support',
        matcher: () => false,
      },
      {
        label: 'Trading Logout', // this label is used by handleNavigation() in ./TradingMenuItem.tsx
        link: '',
        iconmoonWeb: 'icon-tradesmall_logout',
        iconmoonMobile: 'icon-menu3_logout',
        matcher: () => false,
      },
    ],
  },
];

export default realTradingMenu;
